import Box from "ds/components/Box";
import Link from "ds/components/Link";
import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";

import { CellComponentProps } from "../types";

type UsersListItemNameCellProps = CellComponentProps;

const UsersListItemNameCell = ({ user }: UsersListItemNameCellProps) => {
  const userUrl = `/settings/user/${user.id}`;

  return (
    <Box fullWidth gap="large">
      <Link
        analyticsPage={AnalyticsPageOrganization.OrganizationUsers}
        analyticsTitle="User Name Clicked"
        size="small"
        variant="secondary"
        href={userUrl}
      >
        {user.username}
      </Link>
    </Box>
  );
};

export default UsersListItemNameCell;
